import { NgModule } from '@angular/core';
import { TranslateModule } from 'ng2-translate';

import { SlimScrollDirective } from './slim-scroll.directive';


@NgModule({
    imports: [TranslateModule],
    declarations: [
        SlimScrollDirective,
    ],
    exports: [
        SlimScrollDirective,
    ]
})

export class SharedModule {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/shared.module.ts